<template lang="pug">
.cadastro-documentacao
  .cadastro-documentacao__upload-area(
    :id="uploadId"
    @click="abrirSeletor"
  )
    .cadastro-documentacao__upload-icon
      img(src="@/assets/icons/cadastro/file-plus.svg" alt="")
    p.cadastro-documentacao__upload-title Solte a imagem aqui ou clique para selecionar
    p.cadastro-documentacao__upload-hint {{ formatosTexto }}

    .cadastro-documentacao__upload-loading(v-if="loading")
      span {{ percentage }}%

  .cadastro-documentacao__tipo(v-if="arquivoPendente")
    CadastroFormSelect.cadastro-documentacao__tipo-pendente(
      :value="tipoSelecionadoCodigo"
      :options="tiposDisponiveis"
      label-key="descricao"
      value-key="codigo"
      placeholder="Selecione o tipo de documento"
      @input="selecionarTipo"
    )
    button.cadastro-documentacao__anexar(
      type="button"
      :disabled="!tipoSelecionado"
      @click="confirmarAnexo"
    ) Anexar arquivo

  .cadastro-documentacao__content(v-if="documentos.length || tiposDocumentos.length")
    .cadastro-documentacao__tabela-wrapper
      table.cadastro-documentacao__tabela
        thead
          tr
            th Documento enviado
            th Identificação
            th Ações
        tbody
          tr(v-if="!documentos.length")
            td.cadastro-documentacao__empty(colspan="3") Nenhum arquivo adicionado.
          tr(v-for="(doc, index) in documentos" :key="index")
            td {{ doc.nome }}
            td
              CadastroFormSelect.cadastro-documentacao__tipo-select(
                :value="doc.tipoDocumento.codigo"
                :options="tiposDocumentos"
                label-key="descricao"
                value-key="codigo"
                placeholder="Selecione"
                @input="(codigo) => alterarTipoDocumento(doc, codigo)"
              )
            td
              .cadastro-documentacao__acoes
                button.cadastro-documentacao__acao(type="button" @click="visualizar(doc)" title="Visualizar")
                  img(src="@/assets/icons/cadastro/eye.svg" alt="")
                button.cadastro-documentacao__acao(type="button" @click="solicitarRemocao(doc, index)" title="Excluir")
                  img(src="@/assets/icons/cadastro/trash.svg" alt="")

    .cadastro-documentacao__checklist
      p.cadastro-documentacao__checklist-title Documentos necessários
      ul.cadastro-documentacao__checklist-list
        li(
          v-for="tipo in tiposDocumentosObrigatorios"
          :key="tipo.codigo"
          :class="statusClasse(tipo)"
        )
          img(:src="statusIcone(tipo)" alt="")
          span {{ tipo.descricao }}
        li(
          v-if="tipoOutros"
          :class="statusClasse(tipoOutros)"
        )
          img(:src="statusIcone(tipoOutros)" alt="")
          span {{ tipoOutros.descricao }}

  app-resumable(
    :ref="uploadId"
    :target="url"
    :fileType="validExtensions"
    :idDrop="uploadId"
    :idInput="uploadId"
    :maxSize="maxSize"
    :fileTypeErrorCallback="fileTypeErrorCallback"
    @onSuccess="onSuccessEvent"
    @onError="onErrorEvent"
    @onProgress="onProgressEvent"
    @fileAdded="onFileAddedEvent"
  )

  CadastroConfirmDialog(
    :aberto="modalRemocaoAberto"
    :titulo="tituloRemocao"
    :mensagem="mensagemRemocao"
    @cancelar="fecharModalRemocao"
    @confirmar="confirmarRemocao"
  )

  CadastroVisualizarDocumentoDialog(
    :aberto="modalVisualizacaoAberto"
    :titulo="documentoVisualizacao.titulo"
    :url-documento="documentoVisualizacao.url"
    :extensao="documentoVisualizacao.extensao"
    :carregando="documentoVisualizacao.carregando"
    @fechar="fecharModalVisualizacao"
  )
</template>

<script>
import { AppNotificacao } from 'sicarf-components'
import AppResumable from '@/components/AppResumable'
import CadastroFormSelect from '@/components/cadastro/CadastroFormSelect'
import CadastroConfirmDialog from '@/components/cadastro/CadastroConfirmDialog'
import CadastroVisualizarDocumentoDialog from '@/components/cadastro/CadastroVisualizarDocumentoDialog'
import { findByCaminho } from '@/services/documentoService'
import { CADASTRO_EXTENSOES_FOTO_PERFIL } from '@/constants/cadastroPublico'
import { v4 as uuidv4 } from 'uuid'

const MIME_POR_EXTENSAO = {
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}

export default {
  name: 'CadastroDocumentacao',
  components: {
    AppResumable,
    CadastroFormSelect,
    CadastroConfirmDialog,
    CadastroVisualizarDocumentoDialog
  },
  mixins: [AppNotificacao],
  props: {
    documentos: {
      type: Array,
      default: () => []
    },
    tiposDocumentos: {
      type: Array,
      default: () => []
    },
    tiposDocumentosObrigatorios: {
      type: Array,
      default: () => []
    },
    url: {
      type: String,
      required: true
    },
    validExtensions: {
      type: Array,
      default: () => ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx']
    },
    maxSize: {
      type: Number,
      default: 20
    },
    formatosTexto: {
      type: String,
      default: 'doc, docx, jpeg, jpg, pdf, png · Máx. 20MB'
    }
  },
  data () {
    return {
      uploadId: 'cadastro-upload-documentos',
      loading: false,
      percentage: 0,
      arquivoPendente: null,
      tipoSelecionado: null,
      tipoSelecionadoCodigo: '',
      modalRemocaoAberto: false,
      documentoParaRemover: null,
      modalVisualizacaoAberto: false,
      documentoVisualizacao: {
        titulo: '',
        url: null,
        extensao: '',
        carregando: false
      }
    }
  },
  computed: {
    tiposDisponiveis () {
      return this.tiposDocumentos
    },
    tipoOutros () {
      return this.tiposDocumentos.find(tipo => tipo.codigo === 'OUTROS')
    },
    tituloRemocao () {
      return this.$messages.TITULO_WARNING
    },
    mensagemRemocao () {
      return this.$messages.DOCUMENTO_REMOVE_CONFIRM
    }
  },
  methods: {
    solicitarRemocao (doc, index) {
      this.documentoParaRemover = { row: doc, index }
      this.modalRemocaoAberto = true
    },

    fecharModalRemocao () {
      this.modalRemocaoAberto = false
      this.documentoParaRemover = null
    },

    confirmarRemocao () {
      const payload = this.documentoParaRemover
      if (!payload) {
        return
      }

      // Emite antes de fechar: o el-dialog pode disparar cancelar ao fechar.
      this.$emit('removeDoc', payload)
      this.fecharModalRemocao()
    },

    abrirSeletor () {
      if (this.loading) {
        return
      }

      const input = this.$refs[this.uploadId].$el.querySelector('input[type="file"]')

      if (input) {
        input.click()
      }
    },

    fileTypeErrorCallback () {
      this.showNotificacao(
        this.$messages.TIPO_WARNING,
        this.$messages.TITULO_WARNING,
        this.$messages.ARQUIVO_EXTENSION_FAIL.replace('$$', this.validExtensions.join(', '))
      )
    },

    onFileAddedEvent () {
      this.loading = true
      this.percentage = 0
      this.$refs[this.uploadId].uploadFile()
    },

    onProgressEvent (progress) {
      this.percentage = progress
    },

    onErrorEvent () {
      this.loading = false
      this.percentage = 0
    },

    onSuccessEvent (value, fileKey) {
      this.loading = false
      this.percentage = 100
      this.arquivoPendente = {
        id: uuidv4(),
        fileName: value.fileName,
        fileSize: value.fileSize,
        fileKey
      }
      this.tipoSelecionado = null
      this.tipoSelecionadoCodigo = ''
      this.$emit('tipoDocumentoOnChange', null)
    },

    selecionarTipo (codigo) {
      this.tipoSelecionadoCodigo = codigo
      this.tipoSelecionado = this.tiposDocumentos.find(tipo => tipo.codigo === codigo) || null
      this.$emit('tipoDocumentoOnChange', this.tipoSelecionado)
    },

    confirmarAnexo () {
      if (!this.arquivoPendente || !this.tipoSelecionado) {
        return
      }

      if (this.tipoSelecionado.codigo === 'FOTO_PERFIL') {
        const extensao = this.obterExtensao(this.arquivoPendente.fileName)

        if (!CADASTRO_EXTENSOES_FOTO_PERFIL.includes(extensao)) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ARQUIVO_EXTENSION_FAIL.replace(
              '$$',
              CADASTRO_EXTENSOES_FOTO_PERFIL.join(', ')
            )
          )
          return
        }
      }

      this.$emit('addDoc', {
        fileKey: this.arquivoPendente.fileKey,
        fileName: this.arquivoPendente.fileName,
        tipoDocumento: this.tipoSelecionado
      })

      this.arquivoPendente = null
      this.tipoSelecionado = null
      this.tipoSelecionadoCodigo = ''
      this.percentage = 0
      this.$emit('tipoDocumentoOnChange', null)
    },

    alterarTipoDocumento (documento, codigo) {
      const tipo = this.tiposDocumentos.find(item => item.codigo === codigo)

      if (tipo) {
        this.$emit('updateTipoDocumento', { documento, tipo })
      }
    },

    documentoEnviado (tipo) {
      return this.documentos.some(doc => doc.tipoDocumento?.codigo === tipo.codigo)
    },

    statusClasse (tipo) {
      return this.documentoEnviado(tipo)
        ? 'cadastro-documentacao__checklist-item--done'
        : 'cadastro-documentacao__checklist-item--pending'
    },

    statusIcone (tipo) {
      return this.documentoEnviado(tipo)
        ? require('@/assets/icons/cadastro/check.svg')
        : require('@/assets/icons/cadastro/hourglass.svg')
    },

    obterExtensao (nome) {
      if (!nome || !nome.includes('.')) {
        return ''
      }

      return nome.split('.').pop().toLowerCase()
    },

    limparUrlVisualizacao () {
      if (this.documentoVisualizacao.url) {
        URL.revokeObjectURL(this.documentoVisualizacao.url)
      }
    },

    fecharModalVisualizacao () {
      this.modalVisualizacaoAberto = false
      this.limparUrlVisualizacao()
      this.documentoVisualizacao = {
        titulo: '',
        url: null,
        extensao: '',
        carregando: false
      }
    },

    async visualizar (doc) {
      if (!doc?.caminho) {
        return
      }

      this.limparUrlVisualizacao()

      const extensao = this.obterExtensao(doc.nome || doc.caminho)

      this.documentoVisualizacao = {
        titulo: doc.nome || 'Documento',
        url: null,
        extensao,
        carregando: true
      }
      this.modalVisualizacaoAberto = true

      try {
        const arquivo = await findByCaminho(doc.caminho)
        const mimeType = MIME_POR_EXTENSAO[extensao] || (arquivo && arquivo.type) || 'application/octet-stream'
        const blob = new Blob([arquivo], { type: mimeType })

        this.documentoVisualizacao = {
          titulo: doc.nome || 'Documento',
          url: URL.createObjectURL(blob),
          extensao,
          carregando: false
        }
      } catch (e) {
        this.fecharModalVisualizacao()
      }
    }
  },

  beforeDestroy () {
    this.limparUrlVisualizacao()
  }
}
</script>

<style lang="scss" scoped>
.cadastro-documentacao__upload-area {
  align-items: center;
  background: #ffffff;
  border: 1px dashed #eaeaea;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  margin-bottom: 16px;
  min-height: 160px;
  padding: 40px 24px;
  position: relative;
}

.cadastro-documentacao__upload-icon {
  align-items: center;
  background: rgba(24, 197, 194, 0.1);
  border-radius: 12px;
  display: flex;
  height: 48px;
  justify-content: center;
  width: 48px;

  img {
    height: 24px;
    width: 24px;
  }
}

.cadastro-documentacao__upload-title {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  text-align: center;
}

.cadastro-documentacao__upload-hint {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  margin: 0;
  text-align: center;
}

.cadastro-documentacao__upload-loading {
  background: rgba(255, 255, 255, 0.9);
  color: #1e174e;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  inset: 0;
  place-items: center;
  position: absolute;
}

.cadastro-documentacao__tipo {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr auto;
  margin-bottom: 16px;
}

.cadastro-documentacao__tipo-pendente ::v-deep .cadastro-form-select__control.is-placeholder {
  color: #141414;
  font-weight: 700;
}

.cadastro-documentacao__anexar {
  background: #1e174e;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  padding: 0 16px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.cadastro-documentacao__content {
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(0, 1fr) 360px;
}

.cadastro-documentacao__tabela-wrapper {
  border: 1px solid #eaeaea;
  border-radius: 8px;
  overflow: hidden;
}

.cadastro-documentacao__tabela {
  border-collapse: collapse;
  width: 100%;

  th {
    border-bottom: 1px solid #eaeaea;
    color: #8a8a8a;
    font-family: 'Inter', 'Ubuntu', sans-serif;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.14em;
    padding: 16px;
    text-align: left;
    text-transform: uppercase;

    &:last-child {
      text-align: center;
      width: 96px;
    }
  }

  td {
    border-bottom: 1px solid #eaeaea;
    color: #141414;
    font-family: 'Inter', 'Ubuntu', sans-serif;
    font-size: 14px;
    padding: 16px;
    vertical-align: middle;

    &:last-child {
      text-align: center;
    }
  }

  tr:last-child td {
    border-bottom: 0;
  }
}

.cadastro-documentacao__empty {
  color: #8a8a8a;
  text-align: center;
}

.cadastro-documentacao__tipo-select {
  max-width: 100%;
}

.cadastro-documentacao__acoes {
  align-items: center;
  display: flex;
  gap: 4px;
  height: 40px;
  justify-content: center;
}

.cadastro-documentacao__acao {
  align-items: center;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 28px;

  img {
    height: 16px;
    width: 16px;
  }
}

.cadastro-documentacao__checklist {
  border: 1px solid #eaeaea;
  border-radius: 8px;
  padding: 16px;
}

.cadastro-documentacao__checklist-title {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.14em;
  margin: 0 0 16px;
  text-transform: uppercase;
}

.cadastro-documentacao__checklist-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    align-items: center;
    display: flex;
    font-family: 'Inter', 'Ubuntu', sans-serif;
    font-size: 14px;
    gap: 8px;

    img {
      flex-shrink: 0;
      height: 16px;
      width: 16px;
    }
  }
}

.cadastro-documentacao__checklist-item--done span {
  color: #00a73d;
  font-weight: 600;
}

.cadastro-documentacao__checklist-item--pending span {
  color: #8a8a8a;
}

@media (max-width: 1024px) {
  .cadastro-documentacao__content {
    grid-template-columns: 1fr;
  }

  .cadastro-documentacao__tipo {
    grid-template-columns: 1fr;
  }
}
</style>
